'use es6';

import { apiClientProvider } from '../utils/apiClient';
let apiBase = 'ecosystem/v1';
export const setEcosystemApiBase = base => {
  apiBase = base;
};
export const fetchIntegrations = apiClientProvider(apiClient => apiClient.get(`${apiBase}/offerings/summaries?offeringType=APP`));